module.exports = __webpack_public_path__ + "media/images/sit-5ccc5df9.png";